import { compose } from 'recompose';
import HeaderDropDown from './headerDropDown';

const enhance = compose();
export default enhance(HeaderDropDown);
